import { formatDate } from "hooks";
import React from "react";

const OrderWidget = ({ orderNo, deliveryDate, isOverdue }) => {
  return (
    <div className="pb-[5px] pt-[5px] grid">
      <span>{orderNo}</span>

      <span className={`text-[12px] ${isOverdue ? "text-red-500" : ""}`}>
        Delivery Date:{" "}
        <span className="font-medium">{formatDate(deliveryDate)}</span>
      </span>
    </div>
  );
};

export default OrderWidget;
